import { render, staticRenderFns } from "./BidRegister.vue?vue&type=template&id=a5f88ae6&"
import script from "./BidRegister.vue?vue&type=script&lang=js&"
export * from "./BidRegister.vue?vue&type=script&lang=js&"
import style0 from "./BidRegister.vue?vue&type=style&index=0&id=a5f88ae6&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports